document.addEventListener("pickeasyWidgetLoaded", function(e) {
  const upgradeButton = document.getElementById('upgrade-button');
  if (upgradeButton) {
    upgradeButton.disabled = false;
  }
})

document.addEventListener('DOMContentLoaded', async function() {
  const upgradeButton = document.getElementById('upgrade-button');
  const cartItems = Array.from(document.querySelectorAll('.cart-item'));

  async function checkCartValid() {
    const cartDataEl = document.querySelector('[data-cart-json]');
    const cartObject = cartDataEl ? JSON.parse(cartDataEl.innerHTML) : {};
    const hotDeliveryFeeItem = (cartObject?.items || []).find((item) => item.variant_id === hotDeliveryFeeVariant);
    const hotDeliveryItem = (cartObject?.items || []).find((item) => {
      const itemTitleDowncase = item.title.toLowerCase();
      return itemTitleDowncase.indexOf('taxed') !== -1
    });
    const cartHasColdItem = cartItems.find((item) => {
      const variantId = item?.getAttribute('data-variant-id');
      const coldVariantId = item?.getAttribute('data-cold-variant-id');
      return variantId !== '' && coldVariantId !== '' && variantId === coldVariantId;
    });
    if (hotDeliveryItem?.id && (!hotDeliveryFeeItem || cartHasColdItem)) {
      await updateCartVariants();
    }
  }

  await subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    console.log('cartUpdate', event);
    const hotDeliveryFeeRemoved = event.cartData.items_removed.find((item) => item.variant_id === hotDeliveryFeeVariant);
    if (event.cartData.items.length == 1 && event.cartData.items.find((item) => item.id === hotDeliveryFeeVariant)) {
      await removeItemsFromCart([{
        itemKey: event.cartData.items[0].key,
      }]);
      window.location.reload();
    }
    if (hotDeliveryFeeRemoved) {
      await updateCartVariants('cold');
    }
  });

  await checkCartValid();

  if (upgradeButton) {
    upgradeButton.addEventListener('click', async function(e) {
      e.preventDefault();
      await updateCartVariants();
    });
  }

  async function updateCartVariants(deliveryType = 'hot') {
    // Disable the upgrade button during processing
    if (deliveryType === 'hot') {
      upgradeButton.disabled = true;
      upgradeButton.textContent = 'Updating...';
    }

    // Get all cart items and their product data
    const itemsToUpdate = [];

    cartItems.forEach((item, index) => {
      const productHandle = item?.getAttribute('data-product-handle');
      const quantity = item.querySelector('.quantity__input')?.value;

      //if (productHandle && productHandle !== hotDeliveryFeeProductHandle && quantity) {
      if (productHandle && quantity) {
        itemsToUpdate.push({
          itemKey: item.getAttribute('data-item-key'),
          variantId: deliveryType === 'hot' ? item.getAttribute('data-hot-variant-id') : item.getAttribute('data-cold-variant-id'),
          productHandle: productHandle,
          quantity: parseInt(quantity),
        });
      }
    });

    const hasHotDeliveryFeeItem = cartItems.find((item) => {
      const variantId = item.getAttribute('data-variant-id');
      return variantId && parseInt(variantId) === hotDeliveryFeeVariant;
    });

    if (deliveryType === 'hot' && hotDeliveryFeeVariant && !hasHotDeliveryFeeItem) {
      itemsToUpdate.push({
        variantId: hotDeliveryFeeVariant,
        productHandle: hotDeliveryFeeProductHandle,
        quantity: 1,
      });
    }

    if (itemsToUpdate.length === 0) {
      console.error('No items found to update');
      alert('No items found to update. Please make sure you have items in your cart.');
      upgradeButton.disabled = false;
      upgradeButton.textContent = 'YES';
      return;
    }

    // Show progress message
    const progressMessage = document.createElement('div');
    if (deliveryType === 'hot') {
      progressMessage.style.cssText = 'text-align: center; margin: 10px 0; color: #666; font-style: italic;';
      progressMessage.textContent = `Updating items to hot delivery...`;
      upgradeButton.parentNode.appendChild(progressMessage);
    }

    await removeItemsFromCart(itemsToUpdate);
    await addItemsToCart(itemsToUpdate);

    if (deliveryType === 'hot') {
      upgradeButton.disabled = false;
      upgradeButton.textContent = 'YES';
      progressMessage.remove();
    }

    window.location.reload();
  }

  async function removeItemsFromCart(items) {
    var formData = new FormData();
    items.forEach((item, index) => {
      if(item?.itemKey) {
        formData.append(`updates[${item.itemKey}]`, 0);
      }
    });
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => console.log('Remove items from cart: ', data));
  }

  async function addItemsToCart(items) {
    const variants = [];
    items.forEach((item) => {
      variants.push({
        id: item.variantId,
        quantity: item.quantity
      });
    });
    const formData = {
      items: variants
    };

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => console.log('Add items to cart: ', data));
  }
});